export default __webpack_public_path__ + "static/media/relationship.e809400a.png";